var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork, user) {
buf.push("<h1 class=\"iq-headline\">");
if ( artwork.related().partner.get('pre_qualify'))
{
buf.push("Any institutional affiliations?");
}
else
{
buf.push("<span>Any institutional affiliations?</span><span>(Optional)</span>");
}
buf.push("</h1><h2 class=\"iq-subheadline\">Collector groups, memberships, etc.</h2><form class=\"iq-form stacked-form\"><div class=\"iq-form-errors js-form-errors\"></div><textarea rows=\"7\" id=\"institutional_affiliations\" name=\"institutional_affiliations\" class=\"bordered-input\">" + (jade.escape(null == (jade_interp = user.related().collectorProfile.get('institutional_affiliations')) ? "" : jade_interp)) + "</textarea><button type=\"submit\" class=\"avant-garde-button-black is-block iq-next\">Next</button></form>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;